var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { ResponsiveEnums } from "@yodlee/common-components/dist/types/enumerations";
import { NotificationUtils } from "@yodlee/common-components/dist/utilities";
import { Col, Form, Icon, Row, Spin } from "antd";
import React from "react";
import MediaQuery from "react-responsive";
import { extractInlineImages } from "../../components/rich-text-editor";
import { DataUtils } from "../../utilities";
import RightView from "./right-view";
var CreateGlobalNotification = /** @class */ (function (_super) {
    __extends(CreateGlobalNotification, _super);
    function CreateGlobalNotification() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isLoading: false,
            isPreview: false,
            onFormUpdated: false
        };
        _this.componentDidUpdate = function (prevProps, prevState) {
            var onFormUpdate = _this.props.onFormUpdate;
            var isFieldsTouched = _this.props.form.isFieldsTouched;
            var onFormUpdated = _this.state.onFormUpdated;
            var oldOnFormUpdated = prevState.onFormUpdated;
            if (onFormUpdate && isFieldsTouched() && !onFormUpdated && !oldOnFormUpdated) {
                _this.setState({
                    onFormUpdated: true
                }, function () {
                    onFormUpdate();
                });
            }
        };
        _this.componentDidMount = function () {
            var authentication = _this.props.authentication;
            DataUtils.systemConfig(authentication).get().then(function (onload) {
                _this.setState({ onload: onload });
            });
        };
        _this.onSubmit = function (e, isPublish) {
            if (isPublish === void 0) { isPublish = true; }
            var validateFieldsAndScroll = _this.props.form.validateFieldsAndScroll;
            var _a = _this.props, authentication = _a.authentication, onCreate = _a.onCreate;
            var isPreview = _this.state.isPreview;
            e.preventDefault();
            e.stopPropagation();
            validateFieldsAndScroll(function (err, values) {
                console.debug('Received values of globalNotificationForm: ', values, err);
                if (!err) {
                    if (isPreview) {
                        if (isPublish ? values.reviewedBy : true) {
                            _this.setState({
                                isLoading: true
                            });
                            var newGlobalNotification_1 = __assign({}, values);
                            newGlobalNotification_1.isPublish = isPublish;
                            newGlobalNotification_1.fromEmail = newGlobalNotification_1.from;
                            newGlobalNotification_1.includeCsrs = newGlobalNotification_1.includeCSRs || false;
                            var descriptionRichText = newGlobalNotification_1.description || '';
                            var descriptionRawHtml = newGlobalNotification_1.descriptionRawHtml || '';
                            var inlineImageFiles = [];
                            if (descriptionRawHtml) {
                                newGlobalNotification_1.description = "<div id=\"rawHtml\">".concat(descriptionRawHtml, "</div>");
                            }
                            else if (descriptionRichText) {
                                var imageResult = extractInlineImages(descriptionRichText);
                                newGlobalNotification_1.description = "<div id=\"richText\">".concat(imageResult.html, "</div>");
                                inlineImageFiles = imageResult.files;
                            }
                            else {
                                newGlobalNotification_1.description = '';
                            }
                            delete newGlobalNotification_1.descriptionRawHtml;
                            if (newGlobalNotification_1.additionalEmails) {
                                var emails = newGlobalNotification_1.additionalEmails.trim()
                                    ? newGlobalNotification_1.additionalEmails.split(",").map(function (email) { return email.trim(); }).filter(function (email) { return email.length > 0; })
                                    : [];
                                newGlobalNotification_1.additionalEmails = emails;
                            }
                            else {
                                newGlobalNotification_1.additionalEmails = [];
                            }
                            if (!newGlobalNotification_1.brands) {
                                newGlobalNotification_1.brands = [];
                            }
                            if (newGlobalNotification_1.selectedBrandInfos && newGlobalNotification_1.bcc) {
                                newGlobalNotification_1.selectedBrandInfos
                                    .filter(function (brandInfo) { return newGlobalNotification_1.bcc.includes(brandInfo.index); })
                                    .map(function (brandInfo) { return ({ id: brandInfo.id, name: brandInfo.name }); })
                                    .forEach(function (brand) {
                                    if (!newGlobalNotification_1.brands.find(function (item) { return item.id === brand.id; })) {
                                        newGlobalNotification_1.brands.push(brand);
                                    }
                                });
                            }
                            delete newGlobalNotification_1.selectedBrandInfos;
                            delete newGlobalNotification_1.from;
                            delete newGlobalNotification_1.bcc;
                            delete newGlobalNotification_1.includeCSRs;
                            if (newGlobalNotification_1.reviewedBy) {
                                newGlobalNotification_1.reviewedBy = JSON.parse(newGlobalNotification_1.reviewedBy);
                            }
                            var formData_1 = new FormData();
                            inlineImageFiles.forEach(function (file) {
                                formData_1.append("inlineAttachments", file);
                            });
                            if (newGlobalNotification_1.inlineAttachments) {
                                newGlobalNotification_1.inlineAttachments.forEach(function (file) {
                                    formData_1.append("inlineAttachments", file.originFileObj || file);
                                });
                                delete newGlobalNotification_1.inlineAttachments;
                            }
                            if (newGlobalNotification_1.bccAttachmentFiles) {
                                newGlobalNotification_1.bccAttachmentFiles.forEach(function (file) {
                                    formData_1.append("emailListAttachment", file.originFileObj || file);
                                });
                                delete newGlobalNotification_1.bccAttachmentFiles;
                            }
                            if (newGlobalNotification_1.attachmentFiles) {
                                newGlobalNotification_1.attachmentFiles.forEach(function (file) {
                                    formData_1.append("attachments", file.originFileObj || file);
                                });
                                delete newGlobalNotification_1.attachmentFiles;
                            }
                            var globalNotificationRequestBlob = new Blob([JSON.stringify(newGlobalNotification_1)], {
                                type: 'application/json'
                            });
                            formData_1.append("globalNotificationRequest", globalNotificationRequestBlob);
                            DataUtils.globalNotifications(authentication).createOne(formData_1).then(function (globalNotification) {
                                onCreate && onCreate(globalNotification);
                            }).finally(function () {
                                _this.setState({
                                    isLoading: false,
                                    onFormUpdated: false
                                });
                            });
                        }
                        else {
                            NotificationUtils.warning("Reviewed by is missing", "Please provide reviewed by to publish");
                        }
                    }
                    else {
                        _this.setState({ isPreview: true });
                    }
                }
            });
        };
        _this.render = function () {
            var _a = _this.state, onload = _a.onload, isPreview = _a.isPreview, isLoading = _a.isLoading;
            var authentication = _this.props.authentication;
            return (onload ?
                React.createElement(MediaQuery, { minWidth: ResponsiveEnums.SCREEN_SIZE.MD, minDeviceWidth: ResponsiveEnums.SCREEN_SIZE.MD }, function (matches) {
                    return React.createElement(Form, { colon: false, layout: "horizontal", className: "bold-label", onSubmit: _this.onSubmit },
                        React.createElement(Row, { type: "flex", style: { width: '100%' } },
                            React.createElement(Col, { xs: 24, sm: 24, md: 24, lg: 24, xl: 24, xxl: 24 },
                                React.createElement(RightView, { isLoading: isLoading, onload: onload, form: _this.props.form, authentication: authentication, isPreview: isPreview, toggleIsPreview: function () { return _this.setState({ isPreview: !isPreview }); }, onSubmit: function (e, isPublish) { return _this.onSubmit(e, isPublish); } }))));
                }) :
                React.createElement(Row, { type: "flex", style: { height: "80vh" }, justify: "center", align: "middle" },
                    React.createElement(Col, null,
                        React.createElement(Spin, { size: "large", indicator: React.createElement(Icon, { type: "loading" }) }))));
        };
        return _this;
    }
    return CreateGlobalNotification;
}(React.Component));
export default Form.create({ name: 'create-global-notification' })(CreateGlobalNotification);
//# sourceMappingURL=index.js.map